export const LOGO = '/images/logo.png';
export const EMAIL = 'performancelube915@gmail.com';

export const locations = [
  { id: 'gateway', name: 'Gateway', address: '905 Gateway Blvd S', city: 'El Paso, TX 79903', phone: '(915) 975-0650', tel: 'tel:+19159750650' },
  { id: 'desert-meadows', name: 'Desert Meadows', address: '3548 Desert Meadows', city: 'El Paso, TX 79938', phone: '(915) 975-1087', tel: 'tel:+19159751087' },
];

export const directionsUrl = (location) =>
  `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${location.address}, ${location.city}`)}`;

export const navLinks = [
  { name: 'Home', path: '/', id: 'home' },
  { name: 'About us', path: '/about', id: 'about' },
  { name: 'Services', path: '/services', id: 'services' },
  { name: 'Why choose us', path: '/#why', id: 'why-choose-us' },
  { name: 'Our Gallery', path: '/#gallery', id: 'gallery' },
  { name: 'FAQs', path: '/faqs', id: 'faqs' },
  { name: 'Contact Us', path: '/contact', id: 'contact' },
];